import sharedStyles from "./sharedStyles.module.css";

/** @deprecated use mantine features instead of this spacer component */
export function FlexSpacer() {
    return <span className={sharedStyles.stretch} />;
}
